import React from 'react';
import LogInForm from './components/LogInForm';

const LogIn = () => (
  <div className="account jns__login">
    <div className="account__wrapper">

      <div className="login-left">
        <div className="account__card">
          <div className="account__head">
            <div className="account_logo">
              <img className="main-logo" src={`${process.env.PUBLIC_URL}/images/main_logo.png`} alt="JNS Fish Dealer" />
            </div>
          </div>
          <LogInForm onSubmit />
        </div>
      </div>

    </div>
  </div>
);

export default LogIn;
